import { useMutation } from "@apollo/client";
import React from "react";
import {
  Text,
  theme,
  Modal,
  Flex,
  Button,
  Flow,
  Box,
} from "@xometry/xometry_loft";
import { StyledModal } from "../../proposals/Common/Modal/styles";
import {
  ManageOrderInWorkcenterMutationResult,
  ManageOrderInWorkcenterMutationVariables,
  ManageOrderInWorkcenterQuery,
} from "../../../schema/generated/schema";

interface ManageAsJobModalProps {
  modalOpen: boolean;
  toggleModal: (boolean) => void;
  onSubmit?: () => void;
  orderId: string;
}

const ManageAsJobModal: React.FC<ManageAsJobModalProps> = ({
  modalOpen,
  toggleModal,
  onSubmit,
  orderId,
}) => {
  const [manageOrderInWorkCenter, manageOrderInWorkCenterResult] = useMutation<
    ManageOrderInWorkcenterMutationResult,
    ManageOrderInWorkcenterMutationVariables
  >(ManageOrderInWorkcenterQuery);

  const handleSubmit = async () => {
    await manageOrderInWorkCenter({
      variables: {
        orderId,
      },
    });

    onSubmit?.();

    toggleModal(false);
  };

  const closeModal = () => {
    toggleModal(false);
  };

  const loading =
    !!manageOrderInWorkCenterResult.called &&
    manageOrderInWorkCenterResult.loading;

  return (
    <StyledModal isOpen={modalOpen} selector="#modal-mount">
      <Box
        borderBottom={`1px solid ${theme.colors.darkBlues[25]}`}
        marginBottom={theme.space[6]}
        paddingBottom={theme.space[6]}
        className="modal-title"
      >
        <legend>
          <Text kind="body-title">
            Are you sure you want to manage as a job?
          </Text>
        </legend>
        <Modal.CloseButton onClick={closeModal} />
        <Text kind="body" className="modal-title__description">
          Managing your project as a job enables you to track your job progress
          prior to fulfillment, complete task steps, and access Thomas Projects
          from the&nbsp;
          <Text fontWeight={theme.fontWeights.semibold}>Job Management</Text>
          &nbsp; tab. It may take a few minutes for your project to be viewable
          as a job.
        </Text>
      </Box>
      <div className="modal-body">
        <Flex justifyContent="flex-end">
          <Button
            scale="small"
            kind="text"
            onClick={closeModal}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            className="submission-modal__submit-button"
            kind={theme.kind.primary}
            scale="small"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? (
              <Flow scale="panel" kind="disabled" />
            ) : (
              <>
                Manage Job <i className="fas fa-arrow-right" />
              </>
            )}
          </Button>
        </Flex>
      </div>
    </StyledModal>
  );
};

ManageAsJobModal.defaultProps = {
  onSubmit: undefined,
};

export default ManageAsJobModal;
